"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndertekstBold = exports.Undertekst = exports.Normaltekst = exports.Feilmelding = exports.Element = exports.Ingress = exports.Undertittel = exports.Systemtittel = exports.Innholdstittel = exports.Sidetittel = exports.typeConfigMap = void 0;
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("nav-frontend-typografi-style");
exports.typeConfigMap = {
    sidetittel: {
        defaultTag: "h1",
        cls: (...args) => (0, classnames_1.default)("typo-sidetittel", ...args),
    },
    innholdstittel: {
        defaultTag: "h1",
        cls: (...args) => (0, classnames_1.default)("typo-innholdstittel", ...args),
    },
    systemtittel: {
        defaultTag: "h2",
        cls: (...args) => (0, classnames_1.default)("typo-systemtittel", ...args),
    },
    undertittel: {
        defaultTag: "h2",
        cls: (...args) => (0, classnames_1.default)("typo-undertittel", ...args),
    },
    ingress: {
        defaultTag: "p",
        cls: (...args) => (0, classnames_1.default)("typo-ingress", ...args),
    },
    element: {
        defaultTag: "p",
        cls: (...args) => (0, classnames_1.default)("typo-element", ...args),
    },
    feilmelding: {
        defaultTag: "p",
        cls: (...args) => (0, classnames_1.default)("typo-feilmelding", ...args),
    },
    normaltekst: {
        defaultTag: "p",
        cls: (...args) => (0, classnames_1.default)("typo-normal", ...args),
    },
    undertekstBold: {
        defaultTag: "p",
        cls: (...args) => (0, classnames_1.default)("typo-undertekst-bold", ...args),
    },
    undertekst: {
        defaultTag: "p",
        cls: (...args) => (0, classnames_1.default)("typo-undertekst", ...args),
    },
};
function getConfigForType(type) {
    const typeConfig = exports.typeConfigMap[type];
    if (!typeConfig) {
        throw new Error(`Kunne ikke finne typeconfig for ${type}. Støttede typer er: ${JSON.stringify(Object.keys(exports.typeConfigMap))}`);
    }
    return typeConfig;
}
class TypografiBase extends React.Component {
    render() {
        const _a = this.props, { type, tag, className, children } = _a, props = __rest(_a, ["type", "tag", "className", "children"]);
        const config = getConfigForType(type);
        const tagName = tag || config.defaultTag;
        const classnames = { className: config.cls(className) };
        return React.createElement(tagName, Object.assign(Object.assign({}, props), classnames), children);
    }
}
TypografiBase.propTypes = {
    type: PT.string.isRequired,
    tag: PT.string,
    className: PT.string,
    children: PT.node.isRequired,
};
TypografiBase.defaultProps = {
    className: undefined,
};
exports.default = TypografiBase;
var sidetittel_1 = require("./sidetittel");
Object.defineProperty(exports, "Sidetittel", { enumerable: true, get: function () { return __importDefault(sidetittel_1).default; } });
var innholdstittel_1 = require("./innholdstittel");
Object.defineProperty(exports, "Innholdstittel", { enumerable: true, get: function () { return __importDefault(innholdstittel_1).default; } });
var systemtittel_1 = require("./systemtittel");
Object.defineProperty(exports, "Systemtittel", { enumerable: true, get: function () { return __importDefault(systemtittel_1).default; } });
var undertittel_1 = require("./undertittel");
Object.defineProperty(exports, "Undertittel", { enumerable: true, get: function () { return __importDefault(undertittel_1).default; } });
var ingress_1 = require("./ingress");
Object.defineProperty(exports, "Ingress", { enumerable: true, get: function () { return __importDefault(ingress_1).default; } });
var element_1 = require("./element");
Object.defineProperty(exports, "Element", { enumerable: true, get: function () { return __importDefault(element_1).default; } });
var feilmelding_1 = require("./feilmelding");
Object.defineProperty(exports, "Feilmelding", { enumerable: true, get: function () { return __importDefault(feilmelding_1).default; } });
var normaltekst_1 = require("./normaltekst");
Object.defineProperty(exports, "Normaltekst", { enumerable: true, get: function () { return __importDefault(normaltekst_1).default; } });
var undertekst_1 = require("./undertekst");
Object.defineProperty(exports, "Undertekst", { enumerable: true, get: function () { return __importDefault(undertekst_1).default; } });
var undertekst_bold_1 = require("./undertekst-bold");
Object.defineProperty(exports, "UndertekstBold", { enumerable: true, get: function () { return __importDefault(undertekst_bold_1).default; } });
